import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="bg-green-800 text-white py-6 px-4">
        <div className="max-w-3xl mx-auto">
          <Link to="/sms-optin" className="inline-flex items-center text-green-100 hover:text-white mb-4">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back
          </Link>
          <h1 className="text-2xl font-bold">Privacy Policy</h1>
          <p className="text-green-100">AV Realty Management</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-4 py-8 prose prose-slate">
        <p className="text-sm text-slate-500">Last Updated: March 2026</p>

        <h2>1. Information We Collect</h2>
        <p>
          AV Realty Management ("we," "us," or "our") collects information you provide directly to us, including:
        </p>
        <ul>
          <li>Name and contact information (phone number, email address)</li>
          <li>Property and lease information</li>
          <li>Payment and transaction history</li>
          <li>Communications with our team</li>
        </ul>

        <h2>2. SMS/Text Messaging</h2>
        <p>
          When you opt-in to our SMS notification service, we collect your mobile phone number to send you:
        </p>
        <ul>
          <li>Rent payment reminders</li>
          <li>Maintenance and work order updates</li>
          <li>Lease renewal notifications</li>
          <li>Important property announcements</li>
        </ul>
        <p>
          <strong>Message frequency varies.</strong> Message and data rates may apply. You can opt-out at any time by 
          replying STOP to any message. Reply HELP for assistance.
        </p>

        <h2>3. How We Use Your Information</h2>
        <p>We use the information we collect to:</p>
        <ul>
          <li>Manage your tenancy and property services</li>
          <li>Process rent payments and track expenses</li>
          <li>Send important notifications and reminders</li>
          <li>Respond to your requests and inquiries</li>
          <li>Comply with legal obligations</li>
        </ul>

        <h2>4. Information Sharing</h2>
        <p>
          We do not sell, rent, or share your personal information with third parties for their marketing purposes. 
          We may share information with:
        </p>
        <ul>
          <li>Service providers who assist in our operations (e.g., payment processors, SMS providers)</li>
          <li>Property owners as necessary for property management</li>
          <li>Legal authorities when required by law</li>
        </ul>

        <h2>5. Data Security</h2>
        <p>
          We implement appropriate security measures to protect your personal information. However, no method of 
          transmission over the Internet is 100% secure.
        </p>

        <h2>6. Your Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access your personal information</li>
          <li>Correct inaccurate information</li>
          <li>Request deletion of your information</li>
          <li>Opt-out of SMS notifications</li>
        </ul>

        <h2>7. Contact Us</h2>
        <p>
          If you have questions about this Privacy Policy, please contact us at:
        </p>
        <p>
          <strong>AV Realty Management</strong><br />
          Phone: (847) 962-0778<br />
          Email: contact@avrealtymgmt.com
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
